import * as ReactDOM from 'react-dom';

import { Plugin } from '../Plugin';
import { IDashboard, IDashboardContent, IProjectSettings } from '../Interfaces';
import {
  Project,
  IDataStorage,
  IItem,
  IDashboardPage,
  IDashboardParametersBase,
  Todo,
  IStringNumberMap,
  IApp,
} from 'matrix-requirements-sdk/client';
import { sdkInstance } from './../Instance';

export type IDashboardParameters = IDashboardParametersBase;

interface ITraining {
  todo: Todo;
  itemRef: string;
  version: number;
}
interface ITrainingPerUser {
  [login: string]: ITraining[];
}
interface IUserTrainingPerPub {
  [pubName: string]: {
    creationDate: Date;
    trainingsPerUser: ITrainingPerUser;
    itemsWithVersion: { [itemRef: string]: number };
  };
}

export class DashboardPage implements IDashboardPage<IDashboardParameters> {
  settings: IProjectSettings;

  constructor(
    private project: Project,
    private projectStorage: IDataStorage,
    private popupModeOrControl = false,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    private currentFolder: IItem = undefined,
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.settings = {
      ...Plugin.config.projectSettingsPage.defaultSettings,
      ...project
        .getItemConfig()
        .getSettingJSON(Plugin.config.projectSettingsPage.settingName, {}),
    };

    this.config = {
      threshold: 20,
      users: [],
    };
  }

  private config: { threshold: number; users: string[] };

  private saveToLocalStorage() {
    localStorage.setItem(
      'TRAINING_D_' + this.project.getName(),
      JSON.stringify(this.config),
    );
  }
  private loadFromLocalStorage() {
    const savedConfig = localStorage.getItem(
      'TRAINING_D_' + this.project.getName(),
    );
    if (savedConfig) {
      try {
        this.config = JSON.parse(savedConfig);
      } catch (e) {}
    }
  }

  /** Add interactive element in this function */
  renderProjectPage() {
    let container = $(
      `<div class='panel-body-v-scroll fillHeight' style='margin: 10px' ></div>`,
    );

    this.loadFromLocalStorage();
    const control = $(`<div><div style='margin:10px;'>
            <div class="userSelection"></div>
            <div class="threshold"></div>
        </div>
      </div>`).appendTo(container);
    const dashboard: IDashboard = {
      header: { title: 'Dashboard', showFullScreen: false },
      dashboardContent: { settings: this.settings },
    };

    sdkInstance.ml.UI.getPageTitle(
      Plugin.config.dashboard.title ?? 'Training details',
    ).prependTo(sdkInstance.app.itemForm);

    sdkInstance.ml.UI.SelectUserOrGroup.showMultiUserSelect(
      control.find('.userSelection'),
      'Select users (empty for all)',
      this.config.users,
      '',
      '',
      '',
      true,
      false,
      (users) => {
        this.config.users = users;
        this.filterUsers(control, users);
        this.saveToLocalStorage();
      },
    );
    sdkInstance.ml.UI.addDropdownNumber(
      control.find('.threshold'),
      'Specify overdue threshold',
      this.config,
      'threshold',
      1,
      1000,
      () => {
        this.fixThreshold(control, this.config.threshold);
        this.saveToLocalStorage();
      },
    );

    sdkInstance.app.itemForm.append(container);

    let spinningWait = sdkInstance.ml.UI.getSpinningWait('Loading...').appendTo(
      $('.toolbarButtons'),
    );
    //Build the table now.
    let pubContainer = $('<div id="pubContainer">').appendTo(container);
    this.listPub(pubContainer).then(() => {
      this.filterUsers(control, this.config.users);
      this.fixThreshold(control, this.config.threshold);
      (sdkInstance.app as IApp).waitForMainTree(() => {
        $(container).highlightReferences();
        spinningWait.remove();
        this.addCopyPasteButton();
      });
    });
  }

  onResize() {
    /* Will be triggered when resizing. */
  }
  parseDate(dateString?: string): Date {
    if (dateString == undefined) {
      throw new Error('Date string is undefined');
    }
    return new Date(dateString);
  }
  private async listPub(pubContainer: JQuery) {
    let todosPerPubAndUSer = await this.calculateTrainingPerpub();
    console.log(todosPerPubAndUSer);
    //Get all users
    let container = $(`<div>`).appendTo(pubContainer);

    let table = $(
      "<table class='table table-bordered trainingDetailsTable'>",
    ).appendTo(container);
    let thead = $('<thead>').appendTo(table);
    let tbody = $('<tbody>').appendTo(table);
    let tr = $('<tr>').appendTo(thead);
    $('<th>').appendTo(tr).text('User');
    $('<th>').appendTo(tr).text('Item');
    $('<th>').appendTo(tr).text('Revision');
    $('<th>').appendTo(tr).text('Publication');
    $('<th>').appendTo(tr).text('Creation date');
    $('<th>').appendTo(tr).text('Completion date');
    $('<th>').appendTo(tr).text('Days to complete');

    for (let pub of Object.keys(todosPerPubAndUSer)) {
      console.log(pub);

      let pubData = todosPerPubAndUSer[pub];
      for (let user of Object.keys(pubData.trainingsPerUser)) {
        let tr = $(
          `<tr style="font-weight: bold" data-user="${user}"> `,
        ).appendTo(tbody);

        let trainings = pubData.trainingsPerUser[user];
        for (let training of trainings) {
          let tr = $(`<tr data-user="${user}" >`).appendTo(tbody);
          $('<td >').appendTo(tr).text(user);
          $(`<td data-attr="id data-ref="${training.itemRef}" >`)
            .appendTo(tr)
            .text(training.itemRef + '!');
          $('<td>').appendTo(tr).text(training.version.toString());
          $('<td>')
            .append(sdkInstance.ml.Item.renderLink(pub, ' '))
            .appendTo(tr);

          $('<td>')
            .appendTo(tr)
            .html(training.todo.createdAtUserFormat ?? 'unknown');
          $('<td>')
            .appendTo(tr)
            .html(training.todo.closedAtUserFormat ?? 'unknown');
          let overdue = this.config.threshold;
          let now = new Date();
          let todoDate = this.parseDate(training.todo.createdAt);
          let closeDate = new Date();

          if (training.todo.closedAt != undefined) {
            closeDate = this.parseDate(training.todo.closedAt);
          }
          let diff = closeDate.getTime() - todoDate.getTime();
          let diffDays = (diff / (1000 * 3600 * 24)).toFixed(0);
          $('<td>')
            .appendTo(tr)
            .text(
              diffDays.toString() +
                (training.todo.closedAt == undefined ? ' (open)' : ''),
            );
          tr.data('dayToComplete', diffDays);
        }
      }
      container.append('<hr>');
    }
    table.tablesorter({
      sortList: [
        [0, 0],
        [1, 0],
      ],
    });
  }

  private filterUsers(control: any, users: string[]) {
    console.log('Filtering users', users);
    for (let tr of $('table tbody tr', sdkInstance.app.itemForm).toArray()) {
      let user = $(tr).data('user');
      if (users.length == 0 || users.includes(user)) {
        $(tr).show().removeClass('doNotCopy');
      } else {
        $(tr).hide().addClass('doNotCopy');
      }
    }
    for (let pub of $('div[data-pub]', sdkInstance.app.itemForm).toArray()) {
      if ($('table tbody tr:visible', pub).length == 0) {
        $('small', pub).show().removeClass('doNotCopy');
        $('table', pub).hide().addClass('doNotCopy');
      } else {
        $('small', pub).hide().addClass('doNotCopy');
        $('table', pub).show().removeClass('doNotCopy');
      }
    }
  }

  private fixThreshold(control: any, threshold: number) {
    $('tr', sdkInstance.app.itemForm).css('background-color', 'inherit');
    for (let tr of $('table tbody tr', sdkInstance.app.itemForm).toArray()) {
      let days = $(tr).data('dayToComplete');
      if (days > threshold) {
        $(tr).css('background', '#f95c4aaa');
      }
    }
  }

  private async calculateTrainingPerpub() {
    let todosPerPubAndUSer: IUserTrainingPerPub = {};

    let publishedItemListFieldId = this.project
      .getItemConfig()
      .getFieldsOfType('publishedItemList', 'PUB')[0].field.id;
    let mask = this.project.constructSearchFieldMask({ includeFields: true });
    mask.addMask(this.project.getCategory('PUB'), [publishedItemListFieldId]);
    let pubs = await this.project.searchForItems(
      'mrql:category=PUB',
      undefined,
      undefined,
      mask,
    );
    let todosAck = await this.project.getTodos(undefined, true, true, true);

    let todos: Todo[] = [];
    if (todosAck.todos != undefined) {
      todos = todosAck.todos
        ?.filter((todo) => todo.action?.todoType === 'needTraining')
        .sort((a, b) => {
          return (
            this.parseDate(a.createdAt).getTime() -
            this.parseDate(b.createdAt).getTime()
          );
        });
    }
    pubs = pubs.sort((a, b) => {
      return (
        this.parseDate(a.getCreationDate()).getTime() -
        this.parseDate(b.getCreationDate()).getTime()
      );
    });
    console.log(todos);

    for (let pub of pubs) {
      const field = pub.getFieldById(publishedItemListFieldId);
      if (field === null || field === undefined) {
        throw new Error(
          `Unexpected error: unable to find field for id ${publishedItemListFieldId}`,
        );
      }
      let itemsWithVersionString = field.getHandlerRaw().getData() ?? '[]';
      let itemsWithVersion = JSON.parse(itemsWithVersionString) as {
        item: string;
        version: number;
      }[];
      let itemVersionMap: IStringNumberMap = {};

      for (let item of itemsWithVersion) {
        itemVersionMap[item.item] = item.version;
      }

      todosPerPubAndUSer[pub.getId()] = {
        creationDate: this.parseDate(pub.getCreationDate()),
        trainingsPerUser: {},
        itemsWithVersion: itemVersionMap,
      };
    }
    for (let todo of todos) {
      {
        let todoCreationDate = this.parseDate(todo.createdAt);
        let foundPub = '';
        for (let pub of pubs) {
          let pubCreationDate = todosPerPubAndUSer[pub.getId()].creationDate;
          if (pubCreationDate <= todoCreationDate) {
            foundPub = pub.getId();
          }
        }
        if (foundPub != '') {
          let login = todo.login ?? 'unknown';
          if (
            todosPerPubAndUSer[foundPub].trainingsPerUser[login] == undefined
          ) {
            todosPerPubAndUSer[foundPub].trainingsPerUser[login] = [];
          }
          todosPerPubAndUSer[foundPub].trainingsPerUser[login].push({
            itemRef: todo.itemRef ?? 'unknow',
            todo: todo,
            version:
              todosPerPubAndUSer[foundPub].itemsWithVersion[
                todo.itemRef ?? 'unknown'
              ] ?? -1,
          });
        }
      }
    }
    return todosPerPubAndUSer;
  }

  private addCopyPasteButton() {
    $('i', $('.toolbarButtons')).remove();
    sdkInstance.ml.UI.copyBuffer(
      $('.toolbarButtons', sdkInstance.app.itemForm),
      'copy  to clipboard',
      $('#pubContainer', sdkInstance.app.itemForm),
      sdkInstance.app.itemForm,
      (copied: JQuery) => {
        $('.doNotCopy', copied).remove();
        // Different if popup/Control mode
        $("[data-attr='id']", copied).each((i, item) => {
          $(item).text($(item).data('ref') + '!');
        });
      },
    );
    $("<i class='fal fa-file-excel hideCopy' title='Export to excel'></i>")
      .appendTo($('.toolbarButtons'))
      .click(() => {
        const exportToCSV = (text: string, fileName: string) => {
          const hiddenElement = document.createElement('a');
          const date = new Date();
          hiddenElement.href =
            'data:xls/plain;charset=utf-8,' + encodeURIComponent(text);
          hiddenElement.download = `${fileName}-${date.toISOString()}.xls`;
          hiddenElement.click();
        };
        exportToCSV(
          $('.trainingDetailsTable').parent().html(),
          'Training_details',
        );
      });
  }
}
